import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
function RegionalMap() {
  const departments = [{
    id: "01",
    name: "Ain",
    x: "72%",
    y: "28%",
    isBase: false
  }, {
    id: "03",
    name: "Allier",
    x: "28%",
    y: "18%",
    isBase: false
  }, {
    id: "07",
    name: "Ardèche",
    x: "52%",
    y: "82%",
    isBase: false
  }, {
    id: "15",
    name: "Cantal",
    x: "22%",
    y: "68%",
    isBase: false
  }, {
    id: "26",
    name: "Drôme",
    x: "68%",
    y: "78%",
    isBase: false
  }, {
    id: "38",
    name: "Isère",
    x: "78%",
    y: "58%",
    isBase: false
  }, {
    id: "42",
    name: "Loire",
    x: "48%",
    y: "42%",
    isBase: false
  }, {
    id: "43",
    name: "Haute-Loire",
    x: "46%",
    y: "72%",
    isBase: false
  }, {
    id: "63",
    name: "Puy-de-Dôme",
    x: "32%",
    y: "44%",
    isBase: false
  }, {
    id: "69",
    name: "Rhône",
    x: "58%",
    y: "38%",
    isBase: true
  }, {
    id: "73",
    name: "Savoie",
    x: "88%",
    y: "48%",
    isBase: false
  }, {
    id: "74",
    name: "Haute-Savoie",
    x: "92%",
    y: "22%",
    isBase: false
  }];
  return;
}
export default function VisionFondations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="vision-fondations" ref={ref} className="relative w-full overflow-hidden bg-background text-foreground ![padding:128px_0px_128px_0px]">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.02] mix-blend-multiply dark:mix-blend-overlay bg-[radial-gradient(var(--color-primary)_1px,transparent_1px)] [background-size:24px_24px]" />

      {}
      <div className={cn("absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none pointer-events-none z-0 transition-all duration-1000 ease-out", isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95")}>
        <span className="text-[12rem] md:text-[20rem] font-bold leading-none text-transparent" style={{
        WebkitTextStroke: "1px var(--color-primary)",
        opacity: 0.08
      }}>
          01
        </span>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-6">
        <div className="w-full max-w-[800px] mx-auto flex flex-col items-center justify-center text-center gap-8 !h-[500px] md:gap-12">
          {}
          <h2 className={cn("text-sm md:text-base font-mono uppercase tracking-widest text-muted-foreground transition-all duration-700 delay-100", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
            Vision & Fondations
          </h2>

          {}
          <div className={cn("space-y-6 text-center transition-all duration-700 delay-200", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
            <p className="text-2xl font-serif font-light leading-tight text-foreground max-w-full mx-auto md:text-4xl">Fondée en <span className="font-semibold text-primary">2008</span>, Nouvelle Société Du Bâtiment (NSDB) incarne l'alliance exigeante entre <span className="italic">rigueur professionnelle</span> et <span className="italic">proximité relationnelle</span>.</p>
            <p className="text-base text-muted-foreground leading-relaxed max-w-full mx-auto md:text-lg">Depuis plus de 15 ans, nous accompagnons promoteurs et particuliers avec une approche précise et un engagement simple : être le partenaire de confiance qui transforme la complexité technique en sérénité opérationnelle. <br />Animés par la volonté de placer l'humain au centre de nos projets, nous sommes fiers de collaborer avec l'ensemble des acteurs de la construction : Particuliers, Promoteurs, Entreprises, Artisans, Bureaux d'études, Architectes,&nbsp; Fournisseurs, Services d'urbanisme... Autant d'interlocuteurs qui enrichissent notre société et nous permettent de maîtriser l'ensemble des aspects de notre secteur d'activité.</p>
          </div>

          {}
          <div className={cn("w-full mt-8 md:mt-12 transition-all duration-700 delay-300", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
            
          </div>
        </div>
      </div>
    </section>;
}